<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="reviews">
            <div class="col-md-2 hidden-xs">
                <l-side-menu>
                    <l-side-menu-picture :src="icon"></l-side-menu-picture>

                    <l-side-menu-element
                        v-for="item in menu"
                        :key="item.path"
                        :show="item.show"
                        :type="item.type"
                        :icon="item.icon"
                        :label="item.label"
                        :path="item.path"
                        :handler="() => goTo(item.path)"
                        :active="item.active"
                    ></l-side-menu-element>
                </l-side-menu>
            </div>
            <div class="col-md-10">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSideMenu from "@/components/LSideMenu";
import LSideMenuElement from "@/components/LSideMenuElement";
import LSideMenuPicture from "@/components/LSideMenuPicture";

import icon from "@/img/icons/reviews.png";

export default {
    components: {
        LSideMenu,
        LSideMenuElement,
        LSideMenuPicture,
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            reviewsCyclesList: "reviews/assessments/list",
        }),
        menu() {
            return [
                {
                    show: true,
                    icon: "fal fa-home icon-light",
                    label: this.$t("reviews.list.menuToDo"),
                    path: "/reviews/assessments",
                },
                {
                    show: Boolean(this.reviewsCyclesList?.shared?.length),
                    icon: "fal fa-share icon-light",
                    label: this.$t(`reviews.list.menuShared`),
                    path: "/reviews/shared",
                },
                {
                    show: this.user.rights.R_CREATE || this.user.teamRole.hasDirectReports,
                    icon: "fal fa-users icon-light",
                    label:
                        !this.user.rights.IR_VIEW && !this.user.rights.R_CREATE
                            ? this.$t("reviews.list.menuAdminEmployee")
                            : this.$t("reviews.list.menuAdminEmployeeExtended"),
                    path: "/reviews/progress",
                },
                {
                    show: Boolean(
                        this.user.rights.R_CREATE || this.reviewsCyclesList?.templates?.length,
                    ),
                    icon: "fal fa-copy icon-light",
                    label: this.$t("reviews.list.menuTemplates"),
                    path: "/reviews/templates",
                },
                {
                    show: this.user.rights.R_CREATE_AUTO,
                    icon: "fal fa-magic icon-light",
                    label: this.$t("reviews.list.menuAutomations"),
                    path: "/reviews/automations",
                },
                {
                    show: Boolean(
                        this.user.rights.R_CREATE ||
                            this.reviewsCyclesList?.admin?.length ||
                            this.reviewsCyclesList?.adminMoreAvailable,
                    ),
                    icon: "fal fa-calendar-star icon-light",
                    label: this.$t("reviews.list.menuAdminCycle"),
                    path: "/reviews/cycles",
                },
                {
                    show: this.user.rights.R_CREATE || this.user.rights.R_ANALYTICS,
                    icon: "fal fa-analytics icon-light",
                    label: this.$t("reviews.list.menuAnalytics"),
                    path: "/reviews/analytics",
                },
            ];
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.isRouteActive(route.path);
            },
        },
    },
    created() {
        this.icon = icon;
    },
    methods: {
        goTo(path) {
            this.$router.push(path);
        },
        isRouteActive(path) {
            this.menu.forEach(item => {
                this.$set(item, "active", path.startsWith(item.path));
            });
        },
    },
};
</script>

<style scoped></style>
